<template>
  <div class="about OurShop">
    <SubSectionBanner :subSectionData="subSectionData" />
    <section id="servicios" class="secciones seccion-blanca">
      <div class="container">
        <SubSectionStandartHead :subSectionData="subSectionData" />
        <hr />
        <!--  Maps  -->
        <div class="contacto-mapa">
          <br />
          <div class="row">
            <div
              class="col-md-6"
              v-for="(item, index) in itemList"
              :key="item.id_item"
              style="padding-bottom: 55px;"
            >
              <div class="contacto-mapa-lugar">
                <h2>{{ item.title_item_es }}</h2>
                <span v-html="item.desc_item_es"></span>
              </div>
              <div class="mapa">
                <div
                  :id="index == 0 ? 'google_canvas' : 'google_canvas' + (index + 1)"
                  style="width: 100%; height: 100%;"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <TwoModules></TwoModules>
    <News></News>
  </div>
</template>

<script>
import SubSectionBanner from '@/views/components/SubSectionBanner';
import SubSectionStandartHead from '@/views/components/SubSectionStandartHead';
import TwoModules from '@/components/products/TwoModules.vue';
import News from '@/components/products/Guia.vue';
import axios from 'axios';
import { config_settings } from '@/config.js';

export default {
  components: {
    SubSectionBanner,
    SubSectionStandartHead,
    TwoModules,
    News,
  },
  props: ['subSectionData'],
  data() {
    return {
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      cod_sub_sec: this.subSectionData.cod_sub_section,
      options: {
        disableDefaultUI: true,
        scrollwheel: false,
        styles: [
          {
            elementType: 'geometry',
            stylers: [
              {
                color: '#1d2c4d',
              },
            ],
          },
          {
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#8ec3b9',
              },
            ],
          },
          {
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#1a3646',
              },
            ],
          },
          {
            featureType: 'administrative.country',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#4b6878',
              },
            ],
          },
          {
            featureType: 'administrative.land_parcel',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#64779e',
              },
            ],
          },
          {
            featureType: 'administrative.province',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#4b6878',
              },
            ],
          },
          {
            featureType: 'landscape.man_made',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#334e87',
              },
            ],
          },
          {
            featureType: 'landscape.natural',
            elementType: 'geometry',
            stylers: [
              {
                color: '#023e58',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
              {
                color: '#283d6a',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#6f9ba5',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#1d2c4d',
              },
            ],
          },
          {
            featureType: 'poi.business',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#023e58',
              },
            ],
          },
          {
            featureType: 'poi.park',
            elementType: 'labels.text',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#3C7680',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
              {
                color: '#304a7d',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#98a5be',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#1d2c4d',
              },
            ],
          },
          {
            featureType: 'road.arterial',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [
              {
                color: '#2c6675',
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#255763',
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#b0d5ce',
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#023e58',
              },
            ],
          },
          {
            featureType: 'road.local',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'transit',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#98a5be',
              },
            ],
          },
          {
            featureType: 'transit',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#1d2c4d',
              },
            ],
          },
          {
            featureType: 'transit.line',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#283d6a',
              },
            ],
          },
          {
            featureType: 'transit.station',
            elementType: 'geometry',
            stylers: [
              {
                color: '#3a4762',
              },
            ],
          },
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
              {
                color: '#0e1626',
              },
            ],
          },
          {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#4e6d70',
              },
            ],
          },
        ],
      },
      itemList: [],
    };
  },

  updated() {
    this.load_map();
  },

  methods: {
    animation(marcador) {
      if (marcador.getAnimation() != null) {
        marcador.setAnimation(null);
      } else {
        marcador.setAnimation(google.maps.Animation.BOUNCE);
        setTimeout(function() {
          marcador.setAnimation(null);
        }, 750);
      }
    },

    add_markers(mapa, coordenadas) {
      var marcador = null;
      var marcador = new google.maps.Marker({
        map: mapa,
        draggable: false,
        position: new google.maps.LatLng(coordenadas[0], coordenadas[1]),
        visible: true,
        title: 'IFF Perú',
        animation: google.maps.Animation.DROP,
      });

      marcador.setIcon('/favicon.ico');
      google.maps.event.addListener(marcador, 'click', function() {
        if (marcador.getAnimation() != null) {
          marcador.setAnimation(null);
        } else {
          marcador.setAnimation(google.maps.Animation.BOUNCE);
          setTimeout(function() {
            marcador.setAnimation(null);
          }, 750);
        }

        let a = document.createElement('a');
        a.target = '_blank';
        a.href =
          'https://www.google.com/maps/search/?api=1&query=' +
          coordenadas[0] +
          ',' +
          coordenadas[1];
        a.click();
      });
    },

    load_map() {
      this.itemList.forEach((item, index) => {
        let coordenadas = item.prev_desc_item_es.split('|');
        let options = {
          zoom: 17,
          center: new google.maps.LatLng(coordenadas[0], coordenadas[1]),
          scrollwheel: false,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          styles: [
            {
              featureType: 'all',
              elementType: 'all',
              stylers: [
                { gamma: '0.70' },
                { lightness: '-5' },
                { saturation: '30' },
                { weight: '1.2' },
                { hue: '#00acff' },
                { visibility: 'on' },
              ],
            },
            { featureType: 'all', elementType: 'labels', stylers: [{ visibility: 'off' }] },
            {
              featureType: 'administrative',
              elementType: 'all',
              stylers: [{ saturation: '0' }, { lightness: '-10' }],
            },
            {
              featureType: 'administrative',
              elementType: 'labels',
              stylers: [{ visibility: 'on' }],
            },
            {
              featureType: 'administrative.province',
              elementType: 'labels',
              stylers: [{ visibility: 'on' }],
            },
            { featureType: 'landscape', elementType: 'labels', stylers: [{ visibility: 'off' }] },
            { featureType: 'poi', elementType: 'all', stylers: [{ visibility: 'on' }] },
            { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
            { featureType: 'road', elementType: 'all', stylers: [{ visibility: 'on' }] },
            { featureType: 'transit', elementType: 'all', stylers: [{ visibility: 'simplified' }] },
            { featureType: 'transit', elementType: 'labels', stylers: [{ visibility: 'off' }] },
            {
              featureType: 'transit.station.airport',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'transit.station.bus',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'transit.station.rail',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
            { featureType: 'water', elementType: 'all', stylers: [{ visibility: 'on' }] },
            { featureType: 'water', elementType: 'geometry.fill', stylers: [{ color: '#161616' }] },
            { featureType: 'water', elementType: 'labels', stylers: [{ visibility: 'off' }] },
          ],
        };

        if (this.itemList.length == 1) {
          var mapa = new google.maps.Map(document.getElementById('google_canvas'), options);
        } else {
          var mapa = null;
          if (index == 0) {
            mapa = new google.maps.Map(document.getElementById('google_canvas'), options);
          } else {
            mapa = new google.maps.Map(
              document.getElementById('google_canvas' + (index + 1)),
              options,
            );
          }
        }

        this.add_markers(mapa, coordenadas);
        console.log(document.getElementById('google_canvas' + (index + 1)));
      });
    },

    getItems() {
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/sub_sections/' +
            this.cod_sub_sec +
            '/items_all',
        )
        .then((response) => {
          this.itemList = response.data;
          console.log(this.itemList);
        })
        .catch((error) => {
          //console.log(error)
        });
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    getPosition: function(marker) {
      return {
        lat: parseFloat(marker.lat),
        lng: parseFloat(marker.lng),
      };
    },

    toggleInfo: function(marker, key) {
      this.infoPosition = this.getPosition(marker);
      this.infoContent = marker.full_name;
      if (this.infoCurrentKey == key) {
        this.infoOpened = !this.infoOpened;
      } else {
        this.infoOpened = true;
        this.infoCurrentKey = key;
      }
    },
  },

  created() {
    this.scrollToTop();
    this.getItems();
  },
};
</script>

<style lang="scss" src="./OurShop.scss"></style>
